<div class="index" [ngClass]="{ dark: even }"><ion-skeleton-text animated></ion-skeleton-text></div>
<div class="left"><ion-skeleton-text animated [ngStyle]="{width: width}"></ion-skeleton-text></div>
<div><ion-skeleton-text animated></ion-skeleton-text></div>
<div><ion-skeleton-text animated></ion-skeleton-text></div>
<div><ion-skeleton-text animated></ion-skeleton-text></div>
<div><ion-skeleton-text animated></ion-skeleton-text></div>
<div *ngIf="false" class="green no-border"><ion-skeleton-text animated></ion-skeleton-text></div>
<div *ngIf="false" class="raspberry no-border"><ion-skeleton-text animated></ion-skeleton-text></div>
<div *ngIf="false" class="blue no-border"><ion-skeleton-text animated></ion-skeleton-text></div>
<div *ngIf="false" class="purple no-border"><ion-skeleton-text animated></ion-skeleton-text></div>
<div *ngIf="false"><ion-skeleton-text animated></ion-skeleton-text></div>
<div *ngIf="false"><ion-skeleton-text animated></ion-skeleton-text></div>
<div class="bold"><ion-skeleton-text animated></ion-skeleton-text></div>
